import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { About, Home, Tour, Contact, Music, News } from './Containers';
import { Header } from './Components';

class App extends Component {

    state = {
        navOpen: false
    };

    render() {

        return (
            <div className="App">
                <Header />
                <Route exact path="/" component={Home} />
                <Route path="/shows" component={Tour} />
                <Route path="/contact" component={Contact} />
                <Route path="/music" component={Music} />
                <Route path="/about" component={About} />
                <Route path="/news" component={News} />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js